"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEDGER_ACCOUNTS_TYPES = exports.LEDGER_ACCOUNTS_MODES = void 0;
var LEDGER_ACCOUNTS_TYPES = exports.LEDGER_ACCOUNTS_TYPES = ['EXPENSE', 'EMPLOYEE', 'TAXES', 'NON_DEDUCTIBLE', 'DEBIT_CARD', 'CREDIT_CARD'];
var LEDGER_ACCOUNTS_MODES = exports.LEDGER_ACCOUNTS_MODES = ['STATIC', 'DYNAMIC'];